export default {
  "content": "<path d=\"M7 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h2v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM19 2a1 1 0 011 1v18a1 1 0 01-1 1h-2v-2h1V4h-1V2h2zM16 15H8v-2h8v2zM16 11H8V9h8v2zM11 4H9V2h2v2zM15 4h-2V2h2v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};